module.exports = __webpack_public_path__ + "img/bg-3.f8752fda.jpg";